//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/MechanicalRouting.js";
import "../no/Object.js";
import "../no/Session.js";
let d=[[],[[["fittingComponent","portsCount","ports"],"GetPortsFromFitting",{},1,0],[["part","xmlFileName","action","dataTypeToExport","maxSearchLevels"],"ExportCablewayToFile",{},5,0],[["guidObject","attributeName"],"AddGuidToObjectAttribute",{},2,0],[["nodeOccurrence","numOfCoincidentNodes","coincidentNodes"],"GetCoincidentNodes",{},1,0],[["part","numDrcs","drcs"],"GetDuctReinforcementContainers",{},1,0]],[["BuilderFactory","MechanicalRouting.BuilderFactory",0],["ConnectivityService","MechanicalRouting.ConnectivityService",0],["RunsManager","MechanicalRouting.RunsManager",0],["RunsAssignmentManager","MechanicalRouting.RunsAssignmentManager",0],["SpoolManager","MechanicalRouting.SpoolManager",0]]];
SPLM.MechanicalRouting.RoutingManager = class extends SPLM.Object{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.MechanicalRouting.RoutingManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.MechanicalRouting.RoutingManager.DataType = Object.freeze({
    "All" : "All", "Network" : "Network", "Devices" : "Devices"});

export default SPLM;